import { isFullCharterFlight } from "../../sitzplatz-reservierung/shared/fns.misc";
import { loadWebtexte } from "@phoenixreisen/gateway";
import { MAP } from "./constants";
const Model = {
    webtexte: null,
};
export function isExcludedCard(card, booking) {
    return booking?.["buchung/kachel-ausschluss"]?.includes(card) ?? false;
}
export function checkDocuments(booking) {
    const documents = booking["buchung/dokumente"] || null;
    return documents ? documents.length : 0;
}
export function isReversable(booking) {
    return booking["buchung/storno-moeglich?"];
}
export function checkSPAReservationsAmount(booking) {
    let count = 0;
    const travs = booking["buchung/reiseteilnehmer"] || [];
    travs.forEach((trav) => {
        const reservations = trav["reiseteilnehmer/bestaetigte-termine"] || [];
        count += reservations.length;
    });
    return count;
}
export function hasSeatReservations(booking) {
    const travelers = booking["buchung/reiseteilnehmer"] || [];
    for (const trav of travelers) {
        const flights = trav["reiseteilnehmer/flugereignisse"] || [];
        for (const flight of flights) {
            if (isFullCharterFlight(flight) &&
                flight["flugereignis/sitzplatz-reservierung"]) {
                return true;
            }
        }
    }
    return false;
}
export async function getWebtexte() {
    const categories = [
        "uebersicht__banner__text",
        "uebersicht__banner__linktext",
        "uebersicht__emailkonflikt__text",
        "uebersicht__emailkonflikt__linktext",
        "uebersicht__hinweis_fremdseite",
        "uebersicht__hinweis_storniert",
        "uebersicht__badge__parken",
        "uebersicht__konfetti__counter",
    ];
    return loadWebtexte(categories, "webtexte.uebersicht");
}
export async function getBadgesStatus(booking) {
    const badges = {
        spaResCount: checkSPAReservationsAmount(booking),
        hasSMS: booking["buchung/smsassist"] ? true : false,
    };
    return badges;
}
export function checkMandateBanner(booking) {
    const isPhxAgencyNumber = booking["buchung/phoenix-agentur-nr?"] || false;
    const hasAgencyNumber = booking["buchung/agentur-nr"] || null;
    const hasNotYetDecided = booking["buchung/agentur-mandat?"] !== undefined &&
        booking["buchung/agentur-mandat?"] === null;
    return hasAgencyNumber && !isPhxAgencyNumber && hasNotYetDecided;
}
export function getDuration(booking) {
    const cruisetime = booking["buchung/reisezeitraum"];
    const start = cruisetime?.[0] || null;
    const end = cruisetime?.[1] || null;
    const duration = start && end ? `${start} - ${end}` : "";
    return duration;
}
export function isSafariOnIos() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(userAgent);
    const isSafari = /safari/.test(userAgent);
    const isStandalone = "standalone" in window.navigator && window.navigator["standalone"];
    return isIos && isSafari && !isStandalone;
}
export function getShipSlidesData(routes, ships) {
    const slides = [];
    const alreadyIn = {};
    for (const route of routes) {
        if (!alreadyIn[route["route/schiff"]]) {
            slides.push({
                url: route["route/link-schiff"] || "",
                shortname: route["route/schiff"] || "",
                picture: route["route/img-url-schiff"] || "",
                text: route["route/einleitungs-text-schiff"] || "",
                name: ships[route["route/schiff"]] || route["route/schiff"] || "",
                map: MAP[route["route/schiff"]] || null,
            });
            alreadyIn[route["route/schiff"]] = true;
        }
    }
    return slides;
}
export default Model;
